<div class="item" (click)="onItemClicked(item)">
    <div class="item__avatar">
        <div>
            <img class="item__avatar__image" src="{{item.image_url}}" />
        </div>
    </div>
    <div class="item__info">
        <div class="item__info__name">
            {{item.full_name}}
        </div>
    </div>
    <div *ngIf="item.tiSelected && config.showTagsSelectedInDD">
        <img src="../assets/tick.png" alt="tick" width="14">
    </div>
</div>